import {
   AppointmentReceptionService,
   AppointmentReceptionServiceQuery,
} from '@dreryk/egabinet-appointment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import { getCustomFormattingContext, priceRangeFormatter } from '@dreryk/react-common';

export const useCqrsSearchAppointmentReceptionService = (
   appointmentId: number
): UseCqrsQueryResult<AppointmentReceptionService[]> => {
   return useCqrsSearch<AppointmentReceptionService>(() => {
      const query = new AppointmentReceptionServiceQuery();
      query.appointmentId = AppointmentId.of(appointmentId);
      return query;
   });
};

export const useReceptionServicesAsText = (
   receptionServices: AppointmentReceptionService[] | undefined
): string[] | null => {
   if (!receptionServices?.length) {
      return null;
   }

   return receptionServices.map((receptionService) => {
      const { name } = receptionService;
      const minPrice = receptionService.minPrice.asNumber();
      const maxPrice = receptionService.maxPrice.asNumber();

      return `${name} ${priceRangeFormatter(
         {
            min: minPrice,
            max: maxPrice,
         },
         getCustomFormattingContext({
            options: {
               currency: 'PLN',
               stripDecimalZeroes: true,
            },
         })
      )}`;
   });
};

export const useReceptionServiceAsTooltipContent = (receptionServicesAsText: string[] | null): JSX.Element => {
   return (
      <ul>
         {receptionServicesAsText?.map((receptionService) => (
            <li key={receptionService}>{receptionService}</li>
         ))}
      </ul>
   );
};
